
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import _ from 'lodash';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public Opciones: any = null;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        created()
        {
            this.Controlador.Configuracion.Iniciar();
        }

        mounted()
        {
            this.Opciones = _.cloneDeep( this.Controlador.Configuracion.Opciones);
        }

        Cerrar()
        {
            this.Controlador.Configuracion.Opciones = _.cloneDeep( this.Opciones  );
            this.Controlador.Configuracion.Guardar();
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }


    }
